import { Injectable } from '@angular/core';
import { CallableNames, DbService } from '../../db.service';
import { Observable } from 'rxjs';
import { ISessionGroup } from 'src/app/shared/models/session-group/session-group.model';
import { ISession } from 'src/app/shared/models/session-group/session.model';
import { IShopItem } from 'src/app/shared/models/shop-item/shop-item.model';
import { ILecturer } from 'src/app/shared/models/user/lecturer/lecturer.model';
import { IUser } from 'src/app/shared/models/user/user.model';
import { ILocket } from 'src/app/shared/models/locket/locket.model';
import { ICoordinator } from 'src/app/shared/models/user/coordinator/coordinator.model';
import { SessionGroupRegistrationType } from 'src/app/shared/enums/session-group/session-group-registration-types.enum';
import { SessionFormat } from 'src/app/shared/enums/session-group/session-formats.enum';

export interface ISessionLecturerAttendanceSession {
  id: number;
  uuid: string;
  index: number;
  startAt: string | Date;
  endAt: string | Date;
  lecturerAttendanceClosed: boolean;
  format: SessionFormat;
  location: {
    title: string;
    internalTitle: string | null;
  } | null;
  sessionGroup: {
    shopItem: {
      title: string;
    }
  };
  sessionLecturers: {
    lecturer: {
      id: number;
      userId: number;
    };
  }[];
}
export interface ISessionLecturerAttendanceSessionGroup {
  id: number;
  registrationType: SessionGroupRegistrationType;
  sessions: ISessionLecturerAttendanceSession[];
  shopItem: {
    title: string;
  } | null;
  notClosedSessions: ISessionLecturerAttendanceSession[];
}

interface ISessionGroupCanChangeRegistrationTypeData {
  sessionGroupId: number;
};

interface IShopItemsSgLecturersModalGetData {
  shopItemId: number;
};
export interface IShopItemsSgLecturersModalGetResponse {
  shopItem: IShopItem;
  availableLecturers: (ILecturer & { user: IUser & { lockets: ILocket[] } })[];
}

interface IShopItemsSgLecturersModalSetData {
  shopItemId: number;

  lecturerIds: number[];
}

interface ISessionGroupsSiModuleSgLecturersRemoveData {
  sessionGroupLecturerId: number;
};

interface ISessionGroupsSiModuleCoordinatorRemoveData {
  sessionGroupId: number;
  coordinatorId: number;
};

interface IShopItemsSiCoordinatorsModalSetData {
  shopItemId: number;

  coordinatorIds: number[];
}

interface IShopItemsSiCoordinatorsModalGetData {
  shopItemId: number;
};
interface IShopItemsSiCoordinatorsModalGetResponse {
  shopItem: IShopItem;
  availableCoordinators: (ICoordinator & { user: IUser & { lockets: ILocket[] } })[];
}


@Injectable({
  providedIn: 'root'
})
export class SessionGroupsService {

  constructor(
    private dbService: DbService,
  ) { }

  public removeSiCoordinator(data: ISessionGroupsSiModuleCoordinatorRemoveData) {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesSessionGroupsSiModuleCoordinatorRemove, data });
    return this.dbService.handleObs(obs);
  }

  public siCoordinatorsModalSet(data: IShopItemsSiCoordinatorsModalSetData) {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesShopItemsSiCoordinatorsModalSet, data });
    return this.dbService.handleObs(obs);
  }

  public siCoordinatorsModalGet(data: IShopItemsSiCoordinatorsModalGetData): Observable<IShopItemsSiCoordinatorsModalGetResponse> {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesShopItemsSiCoordinatorsModalGet, data });
    return this.dbService.handleObs(obs, { succSilent: true });
  }

  public removeSgLecturer(data: ISessionGroupsSiModuleSgLecturersRemoveData) {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesSessionGroupsSiModuleSgLecturersRemove, data });
    return this.dbService.handleObs(obs);
  }

  public sgLecturersModalSet(data: IShopItemsSgLecturersModalSetData) {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesShopItemsSgLecturersModalSet, data });
    return this.dbService.handleObs(obs);
  }

  public sgLecturersModalGet(data: IShopItemsSgLecturersModalGetData): Observable<IShopItemsSgLecturersModalGetResponse> {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesShopItemsSgLecturersModalGet, data });
    return this.dbService.handleObs(obs, { succSilent: true });
  }

  public canChangeRegistrationType(data: ISessionGroupCanChangeRegistrationTypeData) {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesSessionGroupsCanChangeRegistrationType, data });
    return this.dbService.handleObs(obs, { succSilent: true });
  }

  public getForSessLectAttendance(): Observable<ISessionLecturerAttendanceSessionGroup[]> {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesSessionGroupsGetForSessLectAttendance });
    return this.dbService.handleObs(obs, { succSilent: true });
  }
}
